<template>
  <v-toolbar class="ml-4 wd-100" color="transparent">
    <v-toolbar-title style="font-size: 24px; font-weight: bold"
      >{{ this.projeto }} - Requisitos</v-toolbar-title
    >
    <modal-criar-requisito
      @requisito-criado="getRequisitosByCasoDeUso"
    ></modal-criar-requisito>
  </v-toolbar>

  <v-table
    class="ma-8 mt-1 req--table elevation-1"
    style="background: transparent"
    fixed-header="true"
    density="comfortable"
  >
    <thead class="text-grey">
      <tr>
        <th
          style="border-left: thin solid #efefef"
          class="text-center text-grey"
        >
          Requisito
        </th>
        <th
          style="border-left: thin solid #efefef"
          class="text-center text-grey"
        >
          Descrição
        </th>
        <th
          style="border-left: thin solid #efefef"
          class="text-center text-grey"
        >
          Tipo
        </th>
        <th
          style="border-left: thin solid #efefef"
          class="rounded-te-lg text-center text-grey"
        >
          Observação
        </th>
        <th style="border-left: thin solid #efefef" class="text-left text-grey">
          Ações
        </th>
      </tr>
    </thead>
    <div class="split"></div>
    <tbody>
      <tr v-for="item in requisitos" :key="item">
        <td style="border-left: thin solid #efefef" class="text-center">
          <router-link
            :to="
              '/projects/' + this.idProjeto + '/Requisitos/' + item.id_requisito
            "
            ><p class="text-decoration-underline">
              {{ item.identificacao }}
            </p></router-link
          >
        </td>

        <td style="border-left: thin solid #efefef" class="text-center">
          {{ item.descricao }}
        </td>

        <td style="border-left: thin solid #efefef" class="text-center">
          {{ formatarString(item.tipo_requisito) }}
        </td>

        <td style="border-left: thin solid #efefef" class="text-center">
          {{ item.observacao }}
        </td>
        <td style="border-left: thin solid #efefef" class="text-left">
          <RouterLink
            :to="
              '/projects/' + this.idProjeto + '/Requisitos/' + item.id_requisito
            "
          >
            <v-icon
              size="large"
              color="green-darken-2"
              icon="mdi-eye-arrow-right-outline"
            ></v-icon>
          </RouterLink>
        </td>
      </tr>
    </tbody>
  </v-table>

  <v-container v-if="this.isLoading" class="d-flex justify-center align-center">
    <v-progress-circular class="text-center" indeterminate size="20" />
  </v-container>
</template>

<script scoped>
import axios from 'axios';

import ModalCriarRequisito from '@/components/dialogs/ModalCriarRequisito.vue';
import store from '@/store/store';
/**
 * @module TabelaRequisitos
 * @desc Tabela que mostra a lista de requisitos por CSU.
 * @vue-data {number} [idProjeto=null] - O id do projeto.
 * @vue-data {String} [projeto=''] - Nome do projeto.
 * @vue-data {number} [csuID=null] - O id do caso de uso.
 * @vue-data {number} [reqID=null] - O id do requisito.
 * @vue-data {boolean} [showDialog=false] - Controla a exibição do diálogo.
 * @vue-data {Array} [requisitos=null] - Lista de requisitos.
 * @vue-data {boolean} [isLoading=false] - Loader da tela.
 */
export default {
  name: 'TabelaRequisitos',
  data() {
    return {
      idProjeto: null,
      projeto: '',
      csuID: null,
      reqID: null,
      showDialog: false,
      requisitos: null,
      isLoading: false,
    };
  },
  created() {
    this.idProjeto = this.$route.params.idProjeto;
    this.projeto = localStorage.getItem('projeto');
    this.csuID = this.$route.params.id;
    this.getRequisitosByCasoDeUso();
  },
  methods: {
    /**
     * Obtém a lista de requisitos associados a um caso de uso.
     */
    async getRequisitosByCasoDeUso() {
      this.isLoading = true;
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.get(
          `${apiUrl}/api/v1/requisitos/csu/${this.csuID}`,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          },
        );
        this.requisitos = response.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    /**
     * Formata uma string contendo palavras separadas por underscore (_)
     * para uma string em que as palavras começam com letra maiúscula
     * e o restante das letras são minúsculas e as
     * palavras são separadas por espaço
     *
     * @param {string} string - A string a ser formatada
     * @returns {string} A string formatada
     */
    formatarString(string) {
      const palavras = string.split('_');
      const iniciaisMaiusculas = palavras
        .map(
          (palavra) =>
            palavra.charAt(0).toUpperCase() + palavra.slice(1).toLowerCase(),
        )
        .join(' ');

      return iniciaisMaiusculas;
    },
  },

  components: {
    ModalCriarRequisito,
  },
};
</script>

<style scoped>
.req--table .split {
  background-color: #f9f8f8;
  height: 1rem;
}

.req--table tbody tr {
  background-color: #fff;
}

.req--table a {
  text-decoration: none;
  color: black;
}
</style>
